module.exports = __webpack_public_path__ + "img/dollar.5eb8b716.svg";